import api from 'services/api';

export const updateTranscriptContent = async (
  videoHashId: string,
  shotId: string,
  trasncriptId: string,
  data: { content: string }
): Promise<any> => {
  const response = await api.patch(`/api/videos/${videoHashId}/shots/${shotId}/transcripts/${trasncriptId}/`, data);
  return response;
};

export const removeTranscript = async (videoHashId: string, shotId: string, transcriptId: string): Promise<any> => {
  const response = await api.delete(`/api/videos/${videoHashId}/shots/${shotId}/transcripts/${transcriptId}/`);
  return response;
};
